import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3, Expo } from 'gsap'

import Cover from 'src/components/cover-img'

import raf from 'src/utils/raf'
import resize from 'src/utils/resize'
import values from 'src/values'
import config from 'src/config'
import components from 'src/utils/components'

export default class Grid extends Component {
  constructor(props) {
    super(props)

    this.key = `${this.props.type}-${Math.random()}`
  }

  onClick = () => {
    components.allComponents.worldPlayer.animateIn(this.props.videoBlock.idYt)
  }
  render() {
    const contentSplit = this.props.content.split('<br/><br/>')
    return (
      <div ref="component" className="component grid">
        <div className="wrapper-content">
          <div className="m-grid-10 grid-wrapper">
            <div className="content">
              <h3 dangerouslySetInnerHTML={{ __html: this.props.title }} />
              <p dangerouslySetInnerHTML={{ __html: contentSplit[0] }} />
            </div>
          </div>

          <div
            onClick={this.onClick}
            ref="playerContainer"
            className="player-container">
            <img
              ref="play"
              className="play"
              src={`${process.env.PUBLIC_URL}/img/player/play.png`}
            />

            <img
              className="img-video"
              src={`${process.env.PUBLIC_URL}/img/${
                this.props.videoBlock.cover
              }`}
            />
          </div>
          {contentSplit[1] && (
            <div className="m-grid-10 grid-wrapper">
              <div className="content-s">
                <p dangerouslySetInnerHTML={{ __html: contentSplit[1] }} />
              </div>
            </div>
          )}

          <div
            ref="blockMiddleImgContainer"
            className="block-middle-img-container">
            <img
              src={`${process.env.PUBLIC_URL}/img/${this.props.middleImg}`}
            />
          </div>
          <div
            ref="blockRightImgContainer"
            className="block-right-img-container">
            <img src={`${process.env.PUBLIC_URL}/img/${this.props.rightImg}`} />
          </div>
        </div>
        {this.props.cover && (
          <img
            ref="coverBg"
            className="cover-bg"
            src={`${process.env.PUBLIC_URL}/img/${this.props.cover}`}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/World/mobile/grid/index.js